import React from 'react'
import { useNavigate } from 'react-router-dom';

import ScrollableForm from '../components/foundation/ScrollableForm';
import Button from '../components/buttons/Button';
import TextField from '../components/text/TextField';
import TitleField from '../components/text/TitleField';
import ProductPreview from '../components/design/ProductPreview';

import Footer from '../components/navigation/Footer'

import '../styles/foundation/ThankYou.css';

import { FaArrowRight } from "react-icons/fa";

import boathouserRenteeFrame from '../images/products/boathouserentee/boathouseRenteeFrame.png';
import boathouserRenterFrame from '../images/products/boathouserenter/renterFormIphoneFrame.png';
import nicheWalletFrame from '../images/products/nichewallet/nicheWalletFrame.png';

const ThankYou = () => {

  const navigate = useNavigate();  // Initialize useNavigate

  const products = [
    {
      imgSource: boathouserRenteeFrame,
      title: "Boathouse Rentee App",
      description: "Staff dashboard to manage queues, reservations, and watercraft in real time.",
      orientation: "vertical",
      deviceType: "tablet",
      to: "/products#boathouse-rentee-app"
    },
    {
      imgSource: boathouserRenterFrame,
      title: "Boathouse Renter App",
      description: "Residents scan a QR code, submit a rental request, and receive a text when their watercraft is ready.",
      orientation: "vertical",
      deviceType: "phone",
      to: "/products#boathouse-renter-app"
    },
    {
      imgSource: nicheWalletFrame,
      title: "NicheWallet",
      description: "A secure wallet app for storing and managing all your RA-issued cards.",
      orientation: "vertical",
      deviceType: "phone",
      to: "/products#nichewallet"
    }
  ];

  return (
    <ScrollableForm>
        <section className="thank-you-section">
            <div className="thank-you-hero-container">
                <div className="thank-you-title-container">
                    <TitleField className="thank-you-title" title="Thanks, your message has been sent" bold={true} fontSize="3rem"/>

                    <TextField className="thank-you-subtitle" text="Keep an eye out for a reply from an @nicheware.ca email in your inbox soon." fontColor="#717C54"/>
                </div>

            </div>

            <div className="thank-you-products-container">
                <div className="thank-you-divider-container">
                    <span className="thank-you-divider-text">Our Products</span>
                    <span className="thank-you-divider-line"></span>
                </div>

                <div className="thank-you-products-grid">
                    {products.map((product) => (
                        <ProductPreview
                            key={product.title}
                            imgSource={product.imgSource}
                            title={product.title}
                            description={product.description}
                            orientation={product.orientation}
                            deviceType={product.deviceType}
                            to={product.to}
                        />
                    ))}
                </div>
            </div>
        </section>

        <Footer/>
    </ScrollableForm>
  )
}

export default ThankYou
